/* GOATED shared cart helper: adds one or more variants through Horizon's standard
   cart event so the real cart drawer re-renders and opens. */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const sectionIds = () =>
  [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
const getCart = () => fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

async function add(items, sourceEl) {
  const lines = items.map((i) => ({ id: Number(i.id), quantity: Number(i.quantity || 1) }));
  const total = lines.reduce((s, l) => s + l.quantity, 0);
  const deferred = CartLinesUpdateEvent.createPromise();
  const target = sourceEl && sourceEl.isConnected ? sourceEl : document;
  target.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: lines.map((l) => ({ merchandiseId: String(l.id), quantity: l.quantity })),
      promise: deferred.promise,
    })
  );
  try {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines, sections: sectionIds().join(',') }),
    }).then((r) => r.json());
    const cart = await getCart();
    const failed = !!res.status;
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'goated-cart',
        sourceId: 'goated-cart',
        itemCount: total,
        sections: failed ? undefined : res.sections,
        didError: failed,
      },
    });
    document.dispatchEvent(new CustomEvent('goated:cart', { detail: { cart } }));
    if (failed) throw new Error(res.description || res.message || 'Could not add to bag');
    return cart;
  } catch (err) {
    try { deferred.reject(err); } catch (_) {}
    throw err;
  }
}

window.GoatedCart = { add, getCart, StandardEvents };
document.dispatchEvent(new CustomEvent('goated:cart-ready'));
